// Generated by ReScript, PLEASE EDIT WITH CARE


var dummyResponse = {
    "customer": {
        "auth_token": "dummy_auth_token",
        "mobile": "9999999999"
    }
  };

export {
  dummyResponse ,
}
/* No side effect */
